<div class="address-fields">

  <ion-row>
    <ion-col size="6" sizeMd="4">
      <div class="form-group">
        <ion-label>Flat Number</ion-label>
        <input [(ngModel)]="address.subBuilding" class="form-control" name="subBuilding" [disabled]="disabled" (change)="valueChanged('subBuilding')"/>
      </div>
    </ion-col>
    <ion-col size="6" sizeMd="8">
      <div class="form-group">
        <ion-label>Building Name</ion-label>
        <input [(ngModel)]="address.buildingName" class="form-control" name="buildingName" [disabled]="disabled" (change)="valueChanged('buildingName')" />
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="6" sizeMd="4">
      <div class="form-group">
        <ion-label>Building Number</ion-label>
        <input [(ngModel)]="address.buildingNumber" class="form-control" name="buildingNumber" [disabled]="disabled" (change)="valueChanged('buildingNumber')" />
      </div>
    </ion-col>
    <ion-col size="6" sizeMd="8">
      <div class="form-group">
        <ion-label>Street</ion-label>
        <input [(ngModel)]="address.street" class="form-control" name="street" #street="ngModel" required
          [disabled]="disabled" (change)="valueChanged('street')"/>

        <div [hidden]="street.valid || street.pristine" class="alert alert-danger">
          Street is required
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="form-group">
    <ion-label>City</ion-label>
    <input [(ngModel)]="address.city" class="form-control" name="city" #city="ngModel" required [disabled]="disabled" (change)="valueChanged('city')" />

    <div [hidden]="city.valid || city.pristine" class="alert alert-danger">
      City is required
    </div>
  </div>


  <div class="form-group">
    <ion-label>County</ion-label>
    <input [(ngModel)]="address.county" class="form-control" name="county" #county="ngModel" required [disabled]="disabled" (change)="valueChanged('county')" />

    <div [hidden]="county.valid || county.pristine" class="alert alert-danger">
      County is required
    </div>
  </div>

  <div class="form-group">
    <ion-label>Postcode</ion-label>
    <input [(ngModel)]="address.postCode" class="form-control" name="postCode" #postCode="ngModel" required
      [disabled]="disabled" (change)="valueChanged('postCode')"/>

    <div [hidden]="postCode.valid || postCode.pristine" class="alert alert-danger">
      Postcode is required
    </div>
  </div>
</div>
